import { ConfigService } from 'src/app/shared/services/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { MatDialog } from '@angular/material/dialog';
import { Parametro } from 'src/app/shared/models/parametro';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})

export class ParametrosService {

  private parametroServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(private configService: ConfigService, private dialog: MatDialog, private httpCliente: HttpClient, private tokenService: TokenService) {
    this.parametroServerUri = this.apiUrl + '/' + this.configService.ParametroURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  cParametros() {
    return this.httpCliente.get(this.parametroServerUri + 'CParametros', { headers: this.getHeaders() });
  }
  cParametrosHabilitados() {
    return this.httpCliente.get(this.parametroServerUri + 'CParametrosHabilitados', { headers: this.getHeaders() });
  }
  aParametro(model: Parametro) {
    return this.httpCliente.post(this.parametroServerUri + 'AParametro', model, { headers: this.getHeaders() });
  }
  mParametro(model: Parametro) {
    return this.httpCliente.post(this.parametroServerUri + 'MParametro', model, { headers: this.getHeaders() });
  }
  cParametroDB(codigo: number) {
    return this.httpCliente.get(this.parametroServerUri + 'CParametroDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  cItemsParametros(idParametro) {
    return this.httpCliente.get(this.parametroServerUri + 'CItemsParametros?idParametro=' + idParametro, { headers: this.getHeaders() });
  }
  cItemParametroDB(codigo: number) {
    return this.httpCliente.get(this.parametroServerUri + 'cItemParametroDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  cItemParametroXDescripcionItem(idParametro: number, descripcionItem:string) {
    return this.httpCliente.get(this.parametroServerUri + 'CItemParametroXDescripcionItem?idParametro=' + idParametro + "&descripcionItem=" + descripcionItem, { headers: this.getHeaders() });
  }
  aItemParametro(model: ItemParametro) {
    return this.httpCliente.post(this.parametroServerUri + 'AItemParametro', model, { headers: this.getHeaders() });
  }
  mItemParametro(model: ItemParametro) {
    return this.httpCliente.post(this.parametroServerUri + 'MItemParametro', model, { headers: this.getHeaders() });
  }
  bItemParametro(model: ItemParametro) {
    return this.httpCliente.delete(this.parametroServerUri + 'BItemParametro?codigo=' + model.codigo, { headers: this.getHeaders() });
  }
}